import { render } from "./BannerCarousel.vue?vue&type=template&id=5806b5e0&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"

import "./BannerCarousel.vue?vue&type=style&index=0&id=5806b5e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5806b5e0"]])

export default __exports__